import { useState } from 'react';

/**
 * This hook allows you to add or delete items that are currently loading.
 *
 * It is more convenient than usual `useState`, because it's syntax explicitly says what it's stored for
 */
export const useLoadingItems = () => {
  const [loadingItems, setLoadingItems] = useState([]);

  const addLoadingItem = (id) => {
    setLoadingItems((prev) => [...prev, id]);
  };

  const removeLoadingItem = (id) => {
    setLoadingItems((prev) => prev.filter((itemId) => itemId !== id));
  };

  return { loadingItems, addLoadingItem, removeLoadingItem };
};
